import React from 'react';
import { motion } from 'framer-motion';
import { PORTFOLIO_DATA } from '../data/portfolio';
import { Card } from '../components/ui/Card';
import SafeIcon from '../common/SafeIcon';
import { FiBriefcase, FiCalendar } from 'react-icons/fi';

export const Resume = () => {
  const { experience } = PORTFOLIO_DATA;

  return (
    <div className="max-w-3xl mx-auto space-y-12">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h1 className="text-4xl md:text-5xl font-bold text-white mb-4">Experience</h1>
        <p className="text-xl text-slate-400">
          From scaling enterprise monoliths to bootstrapping indie SaaS.
        </p>
      </motion.div>

      <div className="relative border-l border-slate-700 ml-4 md:ml-6 space-y-12 pb-8">
        {experience.map((exp, index) => (
          <motion.div
            key={exp.id}
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: index * 0.1 }}
            className="relative pl-8 md:pl-12"
          >
            {/* Timeline dot */}
            <span className="absolute -left-[9px] top-1 h-4 w-4 rounded-full bg-indigo-500 ring-4 ring-slate-950"></span>
            
            <Card hover={false} className="!p-6">
              <div className="flex flex-col md:flex-row md:items-center justify-between mb-2 gap-2">
                <h3 className="text-xl font-bold text-white flex items-center">
                  <SafeIcon icon={FiBriefcase} className="mr-2 h-5 w-5 text-indigo-400" />
                  {exp.role}
                </h3>
                <span className="flex items-center text-sm font-medium text-slate-400 bg-slate-800/50 px-3 py-1 rounded-full w-fit">
                  <SafeIcon icon={FiCalendar} className="mr-2 h-4 w-4" />
                  {exp.period}
                </span>
              </div>
              <h4 className="text-lg font-medium text-indigo-300 mb-4">{exp.company}</h4>
              <p className="text-slate-400 leading-relaxed">
                {exp.description}
              </p>
            </Card>
          </motion.div>
        ))}
      </div>
    </div>
  );
};